import { Component, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConfigService } from 'src/app/services/config/config.service';
import { ErrorService } from 'src/app/services/error/error.service';

@Component({
    selector: 'app-information-drawer',
    templateUrl: './information-drawer.component.html',
    styleUrls: ['./information-drawer.component.scss'],
    standalone: false
})
export class InformationDrawerComponent {
  loading: boolean = false;
  url: string = '';
  iframeSafeUrl: SafeResourceUrl = '';

  @ViewChild('informationDrawer') informationDrawer: MatDrawer;

  constructor(
    private configService: ConfigService,
    private errorService: ErrorService,
    private sanitizer: DomSanitizer
  ) {}

  sanitizeUrl(url: string): any {
    this.iframeSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  openDrawer(propertyUrlRef: string) {
    this.loading = true;
    this.informationDrawer.open().then(resp => {
      this.configService.getConfigurationValueByProperty(propertyUrlRef).subscribe(
        resp => {
          this.url = resp as string;
          this.sanitizeUrl(this.url);
          this.loading = false;
        },
        err => this.errorService.onError(err)
      );
    });
  }

  closeDrawer() {
    this.informationDrawer.close();
  }
}
